import { render, staticRenderFns } from "./MTSevereOverYearShow.vue?vue&type=template&id=2275d31a&scoped=true&"
import script from "./MTSevereOverYearShow.vue?vue&type=script&lang=js&"
export * from "./MTSevereOverYearShow.vue?vue&type=script&lang=js&"
import style0 from "./MTSevereOverYearShow.vue?vue&type=style&index=0&id=2275d31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275d31a",
  null
  
)

export default component.exports